import React, { useEffect, useState } from "react";
import "../../assets/styles/payfees.css";

function PayFees() {
  const [student, setStudent] = useState({});
  const [amount, setAmount] = useState(0);

  const studentId = localStorage.getItem("studentId");

  useEffect(() => {
    // FETCH STUDENT DETAILS
    fetch(`https://shuttle-craft-student-transport.onrender.com/api/students/${studentId}`)
      .then((res) => res.json())
      .then((data) => {
        console.log("Student:", data);
        setStudent(data);
      })
      .catch((err) => console.log(err));

    // FETCH PAYMENT DETAILS
    fetch(`https://shuttle-craft-student-transport.onrender.com/api/payments/student/${studentId}`)
      .then((res) => res.json())
      .then((data) => {
        console.log("Payment:", data);

        // if backend returns array
        if (Array.isArray(data)) {
          setAmount(data[0]?.amount || 0);
        }
        // if backend returns object
        else {
          setAmount(data?.amount || 0);
        }
      })
      .catch((err) => console.log(err));
  }, [studentId]);

  return (
    <div className="payments-page">
      <div className="payment-card">
        <h2 className="title">Payments</h2>

        <h2 className="student-info">Student Name: {student?.name}</h2>
        <h2 className="student-info">Batch: {student?.batch}</h2>
        <h3 className="amount">Total Amount ₹{amount}</h3>

        <img
          className="qr"
          src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=upi://pay?pa=6362310247@ybl&pn=ShuttleCraft&am=${amount}&cu=INR`}
          alt="QR Code"
        />

        <br />

        <a
          className="upi-btn"
          href={`upi://pay?pa=6362310247@ybl&pn=ShuttleCraft&am=${amount}&cu=INR`}
        >
          Pay with UPI
        </a>
      </div>
    </div>
  );
}

export default PayFees;
